import axios from '@/http.js';
import qs from 'qs';
export default {
    getWorksById (id) {
        const url = `/api/works/${id}`;
        return axios.get(url);
    },
    getWorksList (param) {
        const url = `api/works`;
        // return axios.post(url, param, config);
        return axios({
            method: 'post',
            url,
            data: param,
          });
    },
    setWorkTags (pid, data) {
      const url = '/api/tag/set/work'
      return axios({
        method: 'put',
        headers: {
          projectId: pid
        },
        url,
        data
      })
    },

    deleteWorks (param) {
        return axios.delete('/api/works', {
            params: {
                ids: param,
            },
            paramsSerializer: params => {
                return qs.stringify(params, {indices: false});
            }
        });
    },
    /**
     * @param param
     * @param status NORMAL, TEMP, 临时存储，不做显示，主要用来做临时导出数据
     * @param syncUpdateCover  是否同步更新截图封面
     * @param defaultUrl 前端截图url
     * @returns {*}
     */
    saveWorks (param, status = 'NORMAL', syncUpdateCover = false, screenshotByCanvas) {
        const url = `api/works/save`;
        param.status = status;
        param.syncUpdateCover = syncUpdateCover;
        param.updateCover = screenshotByCanvas;
        return axios.post(url, param);
    },
    exportWork (param) {
        // return axios.get('api/works/export', {params: param});
        return axios({
            method: 'get',
            url: 'api/works/export',
            params: param,
            responseType: 'blob',
        })
    },
    exportWorks (param, imgType) {
        // return axios.get('api/works/export', {params: param});
        return axios({
            method: 'get',
            url: `api/works/batchExport?type=${imgType}`,
            params: {
                ids: param,
            },
            paramsSerializer: params => {
                return qs.stringify(params, {indices: false});
            },
            responseType: 'blob',
        })
    },
    exportPPT (pid, workId) {
        return axios({
            headers: {
              projectId: pid
            },
            method: 'get',
            url: `api/works/editablePptExport/${workId}`,
            responseType: 'blob',
            // onDownloadProgress(progress) {
            //   console.log(progress);
            // }
        })
    },
    getWorksSize (pid) {
        return axios.get(`api/works/list/widght?projectId=${pid}`);
    },
    getWorkTagList(pid) {
        const url = `/api/tag?type=WORK`;
        return axios.get(url, {
            headers: {
                projectId: pid
            }
        });
    },
    getWorkTags (pid) {
        return axios({
            method: 'get',
            url: '/api/tag/filter',
            headers: {
                projectId: pid
            },
            params: {
                type: 'WORK'
            }
        })
    },
    copyWorks (param) {
        const url = 'api/works/copy';
        return axios.post(url, param);
    },
    getProjectAdmin (pid) {
        const url = `api/users/admins?projectId=${pid}`;
        return axios.get(url);
    },
    rename (param) {
        const url = `api/works/rename`;
        return axios.post(url, param);
    },
    multiSliceExport (id, projectId, imgSuffix) {
      const url = `api/works/multiSliceExport/${id}?imgSuffix=${imgSuffix}`;
      return axios({
        headers: {
          projectId: projectId
        },
        method: 'get',
        url: url,
        responseType: 'blob'
      })
    },
    exportPart (projectId, workId, templateId, templateOnlyId) {
        const url = `api/works/multiDownloadSingle?workId=${workId}&templateId=${templateId}&templateOnlyId=${templateOnlyId}`;
        return axios({
            headers: {
                projectId: projectId
            },
            method: 'get',
            url: url,
            responseType: 'blob'
        })
    },
}